import React, { useEffect } from "react";
import Footer from "../CommonComponent/Footer";
import styled from "styled-components";
import Img404 from "../../assets/404_img.webp";
import { BannerButton, Description, TitleInnerSection } from "../DesignComponent/DesignComponents";
import { metaData } from "../../utils/metaData";
import { trackPageVisit } from "../../utils/pageTracker";
import Footer2 from "../CommonComponent/Footer2";

const PageNotFound = () => {
  useEffect(() => {
    trackPageVisit();
    metaData("50320");
  }, []);

  return (
    <>
      <Section80 className="404page-sec d-flex align-items-center">
        <div className="container">
          <div className="row align-items-center flex-md-row flex-column-reverse">
            <div className="col-md-5 d-flex flex-wrap justify-content-md-start justify-content-center">
              <TitleInnerSection className="mb-3 text-md-start text-center" style={{ color: "#686882" }}>
                Oh no!
                <br /> This page disappeared
              </TitleInnerSection>
              <Description className="mb-4 text-md-start text-center">
                The page you are looking for doesn’t exist or has been moved
              </Description>
              <BannerButton
                to="/"
                className=""
              >
                Go back to home page
              </BannerButton>
            </div>
            <div className="offset-md-1 col-md-6">
              <img src={Img404} alt={"page not found"} className="w-100" />
            </div>
          </div>
        </div>
      </Section80>
      <Footer2 />

      {/* <Footer /> */}
    </>
  );
};

export default PageNotFound;

const Section80 = styled.section`
  min-height: 100vh;
  padding-top: 80px;
  padding-bottom: 80px;
  @media (max-width: 767px) {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;
